<template>
  <div>
    <rabbey-toolbox :filterables="true" @filter-search="search = $event">
    </rabbey-toolbox>

    <el-button
      @click="drawer = true"
      type="warning"
      round
      style="position: relative; bottom: 37px"
      >Crear</el-button
    >
    <!-- drawer add vehicles -->
    <el-drawer
      :title="drawertitleview"
      :append-to-body="true"
      :visible.sync="drawer"
      size="50%"
    >
      <span style="position: relative; bottom: 5px">
        <el-form
          :model="vehicleForm"
          label-position="top"
          label-width="120px"
          style="padding: 5%"
          class="demo-ruleForm"
        >
          <el-form-item label="Marca" prop="vehicleBrand" style="width: 505px">
            <el-input v-model="vehicleForm.Marca"></el-input>
          </el-form-item>
          <el-form-item label="Modelo" prop="vehicleModel" style="width: 505px">
            <el-input v-model="vehicleForm.Modelo"></el-input>
          </el-form-item>
          <el-form-item label="Año" prop="vehicleYear" style="width: 505px">
            <el-input v-model="vehicleForm.Año"></el-input>
          </el-form-item>

          <hr />
          <span style="position: relative; left: 610px; margin-bottom: 115px">
            <h5>Cantidad de Sensores</h5>

            <el-input-number
              style="position: relative; bottom: 15px; right: 12px"
              v-model="value"
              :min="1"
              :max="5000"
            ></el-input-number>
          </span>

          <div
            style="
              display: grid;
              grid-template-columns: auto auto;
              gap: 15px;
              position: relative;
              top: 5px;
            "
            v-for="(inputValue, index) in value"
            :key="index"
          >
            <el-form-item label="Valor de Sensor" prop="vehicleSValu">
              <el-input
                size="mini"
                v-model="inputValues[index]"
                :key="index"
              ></el-input>
            </el-form-item>
            <el-form-item label="Galones de Combustible" prop="vehicleAmountFu">
              <el-input-number
                v-model.number="AmountFuel[index]"
                :key="index"
                :min="0"
                :max="5000"
                style="position: relative; bottom: 3px"
              ></el-input-number>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button type="primary" @click="savedata">Guardar</el-button>
            <el-button @click="drawer = false">Cancelar</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-drawer>
    <!-- drawer editar vehicles -->
    <el-drawer
      :title="drawertitleedite"
      :append-to-body="true"
      :visible.sync="drawer2"
      size="45%"
    >
      <span style="position: relative; top: 15px">
        <el-form
          :model="vehicleFormedit"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="Marca" prop="vehicleBrand" style="width: 505px">
            <el-input v-model="vehicleFormedit.Marca"></el-input>
          </el-form-item>
          <el-form-item label="Modelo" prop="vehicleModel" style="width: 505px">
            <el-input v-model="vehicleFormedit.Modelo"></el-input>
          </el-form-item>
          <el-form-item label="Año" prop="vehicleYear" style="width: 505px">
            <el-input v-model="vehicleFormedit.Año"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="editedata">Guardar</el-button>
            <el-button @click="drawer2 = false">Cancelar</el-button>
          </el-form-item>
        </el-form>
      </span>
    </el-drawer>
    <!-- drawer tabla sensores -->
    <el-drawer
      :title="drawersensor"
      :append-to-body="true"
      :visible.sync="drawer3"
      size="55%"
    >
      <SensorTable :vehicleIdT="vehicleIdT" />
    </el-drawer>
    <rabbey-table3
      ref="tablevehicle"
      :loading="loading"
      :border="true"
      :stripe="true"
      :data="datavh"
      :search="search"
      :columns="columns"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />
  </div>
</template>

<script>
import SensorTable from "./SensorTable.vue";

export default {
  name: "vehicleview",
  data() {
    return {
      loading: false,
      drawer: false,
      drawer2: false,
      drawer3: false,
      vehicleId: 0,
      vehicleIdT: 0,
      value: 1,
      inputValues: [],
      datavehicles: [],
      search: "",
      CompanyCode: this.$store.state.user.user.CompanySelected,
      drawertitleview: "Formulario de Vehiculos",
      drawertitleedite: "Edicion de Vehiculos",
      drawersensor: "Sensores y Combustible",
      datavh: [],
      datasensor: [],
      vehicleForm: {
        Marca: "",
        Modelo: "",
        Año: ""
      },
      vehicleFormedit: {
        Marca: "",
        Modelo: "",
        Año: ""
      },

      // rules: {
      //     vehicleBrand: [
      //     { required: true,message: 'Por Favor rellenar el campo', trigger: 'blur' },
      //   ],
      //   vehicleModel: [
      //     { required: true,message: 'Por Favor rellenar el campo', trigger: 'blur' }
      //   ],
      //   vehicleYear: [
      //     {  required: true,message: 'Por Favor rellenar el campo', trigger: 'blur' }
      //   ],
      //   vehicleSValu: [
      //     {  required: true,message: 'Por Favor rellenar el campo', trigger: 'blur' }
      //   ],
      //   vehicleAmountFu: [
      //     {  required: true,message: 'Por Favor rellenar el campo', trigger: 'blur' }
      //   ],

      // },
      AmountFuel: [],
      editAmountFuel: 0,
      columns: [
        {
          prop: "Id",
          label: "Id",
          minWidth: 100,
          fixed: true
        },

        {
          prop: "vehicle_brand",
          label: "Marca",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "vehicle_model",
          label: "Modelo",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "vehicle_year",
          label: "Año",
          minWidth: 150,
          fixed: true
        }
        // {
        //   prop: "value_sensor",
        //   label: "Valor del Sensor",
        //   minWidth: 200,
        //   fixed: true
        // },
        // {
        //   prop: "Amount_fuel",
        //   label: "Cantidad de galones de combustible",
        //   minWidth: 215,
        //   fixed: true
        // },
      ],

      columnsSensor: [
        {
          prop: "sensorId",
          label: "Id",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "vehicle_Id",
          label: "vehiculo Id",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "value_sensor",
          label: "Valor del sensor",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "Amount_fuel",
          label: "Cantidad de galones de Combustible",
          minWidth: 100,
          fixed: true
        }
      ],

      items: [
        { value: 1, name: 1 },
        { value: 2, name: 2 },
        { value: 3, name: 3 },
        { value: 4, name: 4 },
        { value: 5, name: 5 },
        { value: 6, name: 6 },
        { value: 7, name: 7 },
        { value: 8, name: 8 },
        { value: 9, name: 9 },
        { value: 10, name: 10 },
        { value: 11, name: 11 },
        { value: 12, name: 12 },
        { value: 13, name: 13 },
        { value: 14, name: 14 },
        { value: 15, name: 15 },
        { value: 16, name: 16 },
        { value: 17, name: 17 },
        { value: 18, name: 18 },
        { value: 19, name: 19 },
        { value: 20, name: 20 }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "editar",
          command: "edite"
        },
        {
          icon: "el-icon-view",
          label: "Ver sensores/combustible",
          command: "view"
        }
      ]
      //   actionssensor: [
      //     {
      //       icon: "el-icon-view",
      //       label: "Ver sensores/combustible",
      //       command: "view"
      //     }
      //   ]
    };
  },

  created() {
    this.Getvehicle();
    // this.getsensor();
  },

  components: {
    SensorTable
  },

  methods: {
    // handlePushAction2(command) {
    //   switch (command.command) {
    //     case "edite":
    //       this.drawer3 = true;
    //       this.drawertitleview = "Sensores y Combustible";
    //       break;

    //     default:
    //       break;
    //   }
    // },
    handlePushAction(command) {
      switch (command.command) {
        case "edite":
          this.drawer2 = true;
          //   this.drawertitleview = "Edicion de Vehiculos";
          this.vehicleId = command.row.Id;
          (this.vehicleFormedit = {
            Marca: command.row.vehicle_brand,
            Modelo: command.row.vehicle_model,
            Año: command.row.vehicle_year
          }),
            this.Getvehicle();
          //  console.log('klk command', command.row);
          break;

        case "view":
          this.drawer3 = true;
          //   this.drawertitleview = "Sensores y Combustible";
          this.vehicleIdT = command.row.Id;
          //   console.log('klk prop',this.vehicleIdT);
          break;

        default:
          break;
      }
    },

    savedata() {
      let self = this;
      this.ru;
      var datavehicle = {
        vehicle_brand: this.vehicleForm.Marca,
        vehicle_model: this.vehicleForm.Modelo,
        vehicle_year: this.vehicleForm.Año
      };
      self.$http
        .post("/api/Proyects/addvehicle", datavehicle)
        .then((resp) => {
          if (resp.data) {
            this.vehicledata = resp.data;
            this.inputValues
              .forEach((listFiles1, index) => {
                var url = "/api/Proyects/addvehiclesensor";
                var params = {
                  vehicle_Id: this.vehicledata.Id,
                  value_sensor: listFiles1,
                  Amount_fuel: this.AmountFuel[index]
                };

                //   console.log('klk data array input', listFiles1);
                //   console.log('klk data array gaso', this.AmountFuel[index]);

                this.$http.post(url, params).then((resp) => {
                  //console.log("commente2: ", resp.data);
                  if (resp.data) {
                    this.$message({
                      type: "success",
                      message: "Vehculo Creado exitosamente!"
                    });
                    this.editAmountFuel = 0;
                    this.Getvehicle();
                    this.inputValues = [];
                    this.AmountFuel = [];
                    this.value = 1;
                    self.drawer = false;
                  } else {
                    this.$message.error("Error al agregar Archivo");
                  }
                });

                self.$message({
                  type: "success",
                  message: "El vehiculo se Agrego correctamente"
                });

                self.$emit("success");
              })

              .catch((err) => {
                self.$message({ type: "error", message: err.message });
                console.log("error");
              });
          } else {
            this.$message.error("Error al agregar Archivo");
          }
        })

        .finally(() => {
          // self.count = 0;
          this.editAmountFuel = 0;
          self.drawer = false;
          this.resetForm("");
          this.Getvehicle();
        });
    },
    editedata() {
      let self = this;
      var datavehicle = {
        Id: this.vehicleId,
        vehicle_brand: this.vehicleFormedit.Marca,
        vehicle_model: this.vehicleFormedit.Modelo,
        vehicle_year: this.vehicleFormedit.Año
      };
      self.$http
        .post("/api/Proyects/editevehicle", datavehicle)
        .then(() => {
          self.$message({
            type: "success",
            message: "El vehiculo se edito  correctamente"
          });

          self.$emit("success");
        })
        .catch((err) => {
          self.$message({ type: "error", message: err.message });
          console.log("error");
        })
        .finally(() => {
          // self.count = 0;
          self.vehicleForm = {};
          self.drawer2 = false;
          this.Getvehicle();
        });
    },

    Getvehicle() {
      this.loading = true;
      this.$http
        .get(`/api/Proyects/Getvehicle?CompanyCode=${this.CompanyCode}`)
        .then((resp) => {
          this.datavh = resp.data;
          //    console.log("klk data: ", this.datavh);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

    // getsensor() {
    //   this.loading = true;
    //   this.$http
    //     .get("/api/Proyects/Getvehiclesensor", {
    //       params: {
    //         vehicleId:  this.vehicleId
    //       }
    //     })
    //     .then((response) => {
    //       this.datasensor = response.data;
    //        console.log("klk data",this.datasensor);
    //     })
    //     .finally(() => (this.loading = false));
    // },
  },

  watch: {
    //     inputValues(value){
    //      console.log('klk valor', value)
    //    },
    //    AmountFuel(value){
    //      console.log('klk valor amount', value)
    //    },
  }
};
</script>

<style></style>
